<template>
  <v-card>
    <v-container fluid>
      <v-layout row wrap align-center justify-center fill-height>
        <v-flex xl6 lg6 md6 sm6 hidden-xs-only>
          <v-btn style="margin:0px" flat icon color="primary" v-on:click="refresh">
            <v-icon>cached</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xl6 lg6 md6 sm6 xs12 text-lg-right>
          <v-text-field style="padding:0px; margin:0px" id="searchBox" single-line v-model="searchValue"
            @keydown.enter="enter" placeholder="Buscar" append-icon="search" light hide-details></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider style="margin:0px"></v-divider>
    <v-card-text style="padding-top:0px">
      <v-data-table flat v-bind:pagination.sync="pagination" item-key="id" v-model="selected"
        :items="bonusProductionPending" :headers="headers" class="v-table-list compact theme--light"
        :rows-per-page-text="$t('message.rowsByPage')">
        <template slot="headers" scope="props">
          <tr class="border-buttom">
            <th v-for="header in props.headers" :key="header.text"
              :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)">
              {{ header.text }}
              <v-icon>arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" scope="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
             <td class="text-xs-left cut-text">{{ props.item.sucursal }}</td>
            <td class="text-xs-left cut-text">{{ props.item.bonusType }}</td>
            <td class="text-xs-left cut-text">{{ props.item.lineBusiness }}</td>
            <td class="text-xs-left cut-text">{{ props.item.product }}</td>
            <td class="text-xs-left cut-text">{{ props.item.ramo }}</td>
            <td class="text-xs-left cut-text">{{ props.item.policy }}</td>
            <td class="text-xs-left cut-text">{{ props.item.endorsement }}</td>
            <td class="text-xs-left cut-text">{{ nzDate(props.item.creationDate) }}</td>
            <td class="text-xs-left cut-text">{{ props.item.clientIdentification }}</td>
            <td class="text-xs-left cut-text">{{ props.item.clientName }}</td>
            <td class="text-xs-left cut-text">{{ props.item.totalValue | currency }}</td><!-- 
            <td class="text-xs-left cut-text">{{ props.item.status }}</td> -->
          </tr>
        </template>
        <template slot="no-data">
          <div>{{ $t('message.noPreliquidations') }}</div>
        </template>
        <template slot="pageText" slot-scope="props">{{ props.pageStart }} - {{ props.pageStop }} {{ $t('message.of') }}
          {{ props.itemsLength }}</template>
      </v-data-table>
      <v-row no-gutters class="mt-4">
        <v-col cols="12" class="considerations-box">
          <div><strong>Consideraciones:</strong></div>
          <div>
            Recuerda que los bonos son válidos por <strong>90&nbsp;días</strong> a partir de la fecha de creación.
          </div>
        </v-col>
      </v-row>


    </v-card-text>
  </v-card>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";

export default {
  computed: {
    ...mapGetters([
      "loadingBonusProduction",
      "bonusProductionPending",
      "agency"
    ])
  },
  mounted() {
    this.$store.dispatch("getBonusProductionPending");
  },
  methods: {
    nzDate: nzDate,
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.bonusProductionPending.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    refresh() {
      this.$store.dispatch("getBonusProductionPending");
    },
    enter() {
      if (this.searchValue != "") {
        this.$store.dispatch("getBonusProductionPending", this.searchValue);
      } else {
        this.$store.dispatch("getBonusProductionPending");
      }
    }
  },
  watch: {
    loadingBonusProduction(val) {
      if (val) {
        this.$root.$emit(
          "showLoading",
          "Cargando información, por favor espere..."
        );
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val) {
      this.$store.dispatch("getBonusProductionPending");
    }
  },
  data() {
    return {
      searchValue: "",
      matches: [],
      pagination: {
        sortBy: "date"
      },
      selected: [],
      headers: [
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.Agency"),
          value: "sucursal",
          width: "15%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.bonusType"),
          value: "bonusType",
          width: "15%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.businessLine"),
          value: "businessLine",
          width: "15%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.product"),
          value: "product",
          width: "15%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.ramo"),
          value: "ramo",
          width: "15%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.policy"),
          value: "policy",
          width: "15%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.endorsement"),
          value: "endorsement",
          width: "15%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.datePreliquidation"),
          value: "creationDate",
          width: "15%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.clientIdentification"),
          value: "clientIdentification",
          width: "15%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.clientName"),
          value: "clientName",
          width: "15%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.value"),
          value: "totalValue",
          width: "15%"
        }/* ,
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "status",
          width: "15%"
        } */
      ]
    };
  }
};
</script>
<style>
.considerations-box {

  padding: 8px 12px;
  font-size: 14px;
  border-radius: 3px;
  line-height: 1.4;
}

</style>
